import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { ViewService, SecurityService, Security } from "../../../common";

@Component({
  templateUrl: "./security-detail-view.html",
  standalone: false,
})
export class SecurityDetailView implements OnInit, OnDestroy {
  subscriptions: any[];
  role: Security;

  constructor(
    private viewService: ViewService,
    private dataService: SecurityService,
    private route: ActivatedRoute
  ) {
    viewService.setViewData({ pageTitle: "Security Details" });
  }

  ngOnInit() {
    this.subscriptions = [
      this.route.params.subscribe((params) => {
        this.dataService.get(params["roleId"]).subscribe((role) => {
          this.role = role;
          this.viewService.setViewData({
            pageTitle: `${role.name}`,
            link: { text: "» Edit", routeData: this.viewService.routerLink(["edit"]) },
          });
        });
      }),
    ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
